import appFeatures from 'effective-features!';
import rootTemplate from 'text!portal/views/root.html';
import faqConfig from 'portal/config/faq.json';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import 'angularRouter';
import AuthConfigUtil from 'gw-portals-auth-js/utils/AuthConfigUtil';
import GetXcenterEntryPoint from 'gw-portals-platform-js/entryPoint/GetXcenterEntryPoint';
import {getConfigValue} from 'gw-portals-config';

// Flag to separate /app (Dev) and distribution builds
const IS_DISTRIBUTION_BUILD = /* DISTRIBUTION_BUILD_START*/true/* DISTRIBUTION_BUILD_END*/;

/**
 * Module used to define application level configuration parameters that should be
 * passed to capability modules
 */

export default angular.module('portal.config', ['ui.router'])

/**
 * Defines the prefix url where the set of states for a sub module should
 * plug into the portal application
 */
    .constant('state_plugin_config', getConfigValue('appSettings.statePathConfig'))
    .constant('httpSettings', getConfigValue('httpSettings'))
    .constant('fnolConfig', getConfigValue('appSettings.fnolConfig'))
    // Used for date of birth dropdowns.
    .constant('AgeAllowedToDrive', getConfigValue('AgeAllowedToDrive', 16))
    .constant('MaximumAge', getConfigValue('MaximumAge', 100))
    // 50MB. Used to specify the maximum file size for document upload.
    .constant('maxFileUploadSize', getConfigValue('maxFileUploadSize', 50000000))
    .constant('defaultLocaleDetails', getConfigValue('userSettings.defaultLocaleDetails'))
    .config(['$stateProvider', '$urlRouterProvider', ($stateProvider, $urlRouterProvider) => {
        const states = [{
            name: 'root',
            url: '',
            template: rootTemplate,
            abstract: true,
            resolve: {
                proceedToHomePage: ['oAuth', (oAuth) => {
                    const authenticationService = AuthenticationService(oAuth);
                    return authenticationService.waitForLoginRequestComplete;
                }]
            }
        }];

        for (let i = 0; i < states.length; i++) {
            $stateProvider.state(states[i]);
        }

        var tempUrl = localStorage.getItem('tempUrl');
        var tempUrlTime = localStorage.getItem('setTimeOut');
        //Don't store the home page URL of the portal to restrict the looping
        var urlArray =  window.location.href.split(".html");
        if(((tempUrl == null || tempUrl == undefined) ||
        (tempUrlTime != null && (new Date().getTime()-tempUrlTime) > 120000))
            && urlArray.length == 2 && urlArray[1].length > 15){
            localStorage.setItem('tempUrl', window.location.href);
            localStorage.setItem('setTimeOut', new Date().getTime());
            console.log(localStorage.getItem('tempUrl'));
        }

        $urlRouterProvider.when('/account-policy-details/{policyNumber}', '/policies/{policyNumber}/summary');
        $urlRouterProvider.otherwise('/home');
    }])

    .constant('config.supportPhone', '800-555-1212')

    .constant('ASYNC_TRANSLATIONS', true) // Constant that allows us to load translations synchronously (tests/Components Examples)
    .constant('ANGULARI18N_PRESET', '') // Constant that allows us to load Angular Locale from different path (Components Examples)
    .constant('TRANSLATE_PROVIDER_PREFIX', '') // Constant that allows us to load translations from different path (Components Examples)
    .constant('FAQ_CONFIG', faqConfig)
    .constant('OLDEST_CAR_YEAR', 1908)

    .constant('AGENT_REPORTS', [{
        type: 'growth',
        nameId: 'portal.infocenter.tab.Growth',
        icon: 'edit',
        enabled: true,
        reportUrl: '../styles/images/ic/1.png'
    }, {
        type: 'ratios',
        nameId: 'portal.infocenter.tab.Loss Ratios',
        icon: 'bar-chart',
        enabled: true,
        reportUrl: '../styles/images/ic/2.png'
    }])
    .constant('COMMISSIONS', [{
        type: 'commissionsToDate',
        nameId: 'portal.infocenter.tab.MTD and YTD Commission',
        icon: 'pie-chart',
        enabled: true,
        commissionReportUrl: '../styles/images/ic/1.png'
    }, {
        type: 'statements',
        nameId: 'portal.infocenter.tab.Statements',
        icon: 'list-alt',
        enabled: true,
        commissionReportUrl: '../styles/images/ic/2.png'
    }])
    .constant('oAuth', (() => {
        const authServer = appFeatures.auth.authServer;
        const authConfig = getConfigValue('auth')[authServer];
        const clientId = AuthConfigUtil.getPortalClientId('GatewayApplication', IS_DISTRIBUTION_BUILD);

        if (!authConfig.clientId) {
            authConfig.clientId = clientId;
        }

        authConfig.portalName = GetXcenterEntryPoint(IS_DISTRIBUTION_BUILD);
        authConfig.refreshRedirectPage = appFeatures.oAuthRedirectHomePage;
        return authConfig;
    })())
    .constant('sessionConfig', getConfigValue('userSettings.sessionConfig', {
        inactivityIntervalMins: 1440,
        logoutConfirmationIntervalMins: 1
    }))
    .constant('INFOCENTER_GPA_REPORT_API_ENDPOINTS', {
        commissions_rest_api: "/rds/reportData/searchPath/content/folder[@name='Guidewire']/folder[@name='Embeddable Widgets']/folder[@name='Producer']/folder[@name='Producer Commissions']/folder[@name='Producer Commission Sources']/report[@name='Producer Commission Data']?fmt=JSON"
    })
    .value('GPA_PC_ENTRY_POINT', `${GetXcenterEntryPoint(IS_DISTRIBUTION_BUILD)}/pc/GatewayPortal.do`);

